import { RootState } from "../../../store";
import {
  cloudChiprApi,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { AccountTabs } from "../../../../components/pages/accounts-group/utils/types/types";
import { getAccountsSortBySettingsKey } from "../../../../components/pages/account/utils/hooks/useAccountsSortBy.hook";
import { accountsSortBySelector } from "../slice-data/accountsSortBySelector";

const selector =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select;

export const accountsSortByLoadingSelector = (
  state: RootState,
  provider: ProviderType,
  tabValue: AccountTabs,
  orgId?: string,
) => {
  const sortBy = accountsSortBySelector(state);
  const key = getAccountsSortBySettingsKey(provider, tabValue, orgId);

  const data = selector({ key })(state);

  return data?.error || sortBy ? false : data.isLoading;
};
